import flatten from 'lodash/flatten';
import UserService from '../services/user';

const hasPermissionBase = checker => (...inputPermissions) => {
  const permissions = flatten([...inputPermissions]);
  return checker(permissions);
};

const hasPermission = hasPermissionBase(
  permissions => UserService.hasPermission(...permissions),
);
const hasAnyPermission = hasPermissionBase(
  permissions => UserService.hasAnyPermission(...permissions),
);

export default {
  install(Vue) {
    Object.defineProperties(Vue.prototype, {
      $hasUserPermission: {
        get: () => hasPermission,
      },
      $hasUserAnyPermission: {
        get: () => hasAnyPermission,
      },
    });
  },
};
